import React, { useEffect, useReducer } from 'react';
import Context from './context';
import { UserInfo } from '@/config/api';
import { eventBus } from '@/utils/eventBus';


type ACTIONTYPE = { type: 'setData'; data: any };

const reducer = (state: any, action: ACTIONTYPE) => {
  switch (action.type) {
    case 'setData':
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export enum PageStatus {
  ERROR = 'error',
  NOLOGIN = 'nologin',
  NORMAL = 'normal',
}

export interface AppState {
  pageStatus:  PageStatus;
  account: string;
  cameraDeviceId: string;
  microphoneDeviceId: string;
  userInfo: UserInfo;
  agreedCheck: boolean;
  userInfoList: UserInfo[];
}

export const GlobalDataProvider = (props: any) => {
  const { children } = props;
  const site = sessionStorage.getItem('videoAudit-site');
  const userInfoList = JSON.parse(sessionStorage.getItem('videoAudit-userInfoList') || '[]') as UserInfo[];
  const initInfo: UserInfo = {
    id: '',
    expired: false,
    expiredTime: '',
    flowTemplateId: '',
    phone: '',
    qymc: '',
    registeredTime: '',
    ryxm: '',
    yyzzhm: '',
    mailUrl: '',
    invitedCode: '',
    isFaceVerification: 0,
    materialInformation: '',
    hasAuditTask: false,
    site: 'US',
    siteName: '美国'
  };
  const initState: AppState = {
    pageStatus: (sessionStorage.getItem('videoAudit-pageStatus') as PageStatus) || PageStatus.NOLOGIN,
    account: localStorage.getItem('videoAudit-account') || '',
    cameraDeviceId: '',
    microphoneDeviceId: '',
    userInfoList,
    userInfo: userInfoList.find?.(item => item.site === site) || initInfo,
    agreedCheck: sessionStorage.getItem('videoAudit-agreedCheck') ? JSON.parse(sessionStorage.getItem('videoAudit-agreedCheck')!) : false,
  };

  // 初始化reducer
  const [state, dispatch] = useReducer(reducer, initState);
  const GetgeneralConfig = async () => {
  };
  const initApp = () => {
    GetgeneralConfig();
  };
  // 初始化
  useEffect(() => {
    initApp();
  }, []);

  useEffect(() => {
    // 监听用户dispatch更新事件
    const listener = (data?: any) => {
      dispatch({ type: 'setData', data });
    };
    
    eventBus.on('eventBusDispatch', listener);
    
    return () => {
      // 清理监听器
      eventBus.off('eventBusDispatch', listener);
    };
  }, [dispatch]);

  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};
